export default __webpack_public_path__ + "static/media/bike_image5.6ca0bd0c.jfif";